<template>
  <transition name="fade" mode="out-in">
    <div v-if="isLoading" class="shimmer h-[22px] w-28 rounded-full" />
    <button v-else-if="amount > 0" type="button" class="label" v-bind="$attrs">
      <span class="freedom-loyalty-text text-xs font-semibold">
        <slot v-bind="{ value: prettyPrice(amount) }">
          {{ t('cashback', { value: `${prettyPrice(amount)}` }) }}
        </slot>
      </span>
    </button>
  </transition>
</template>

<script setup lang="ts">
  import type { Pfm } from '@aviata/platform-client';
  import { useI18n } from 'vue-i18n';
  import { prettyPrice } from '@aviata/text-fns';
  import { useFreedomCashback } from '../model';

  const { t } = useI18n();

  interface Props {
    pfm: Pfm;
    offerPrice?: string | number;
    billId?: string;
  }

  const props = defineProps<Props>();

  const { amount, isLoading } = useFreedomCashback({
    pfm: props.pfm,
    offerPrice: props.offerPrice,
    billId: props.billId,
  });
</script>

<i18n src="../config/locales.json"></i18n>

<style scoped>
  .label {
    @apply flex items-center space-x-1 rounded-full px-1.5 py-0.5;
    box-shadow: 0 2px 8px 0 #00000014;
  }
</style>
